import styled from 'styled-components';
import { brandColors } from 'styles/colors';

export const SuccessMessage = styled.div`
	color: ${brandColors.green};
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
	margin-left: 8px;
`;

export const MessageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 22px;
`;
